import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Result, Button } from 'antd';

type Props = { children: ReactNode };
type State = { error: Error | null };

/**
 * 路由级错误边界。
 *
 * 注意：[CODING_STANDARDS §4.1] 通用规则是"不用 class 组件"，但 React 的 Error
 * Boundary 当前只能用 class 组件实现（无 hooks 等价物）。这是该规则的**唯一**已知例外，
 * 不要扩展到其它地方。
 */
// eslint-disable-next-line react/prefer-stateless-function
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <Result
          status="500"
          title="页面出错了"
          subTitle="请稍后再试，或刷新页面。"
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              刷新页面
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}
